import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RolGuard } from 'src/app/services/auth/rol.guard';
import { ComplementoWebComponent } from './complemento-web.component';
import { ConsultaPrincipalComponent } from './consulta-principal/consulta-principal.component';
import { DetalleComplementoComponent } from './@components/detalle-complemento/detalle-complemento.component';

const complementoWeb: Routes = [
    {
        path: '',
        component: ComplementoWebComponent,
        children: [
            { canActivate: [], path: 'consulta', component: ConsultaPrincipalComponent, data: { titulo: 'Complemento web' }  },
            { canActivate: [], path: 'consulta/detalle/:siniestro', component: DetalleComplementoComponent, data: { titulo: 'Detalle siniestro' }  },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(complementoWeb),
    ],
    exports: [RouterModule]
})
export class ComplementoWebRoutingModule { }

